/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import * as schema from '@engine/actions/schema';
import { EMAIL_CONFIGURATIONS_UPDATE, EMAIL_CONFIGURATION_DESTROY, EMAIL_TEMPLATES_UPDATE, EMAIL_TEMPLATE_DESTROY } from '@engine/actions/action-types';
import { normalize } from 'normalizr';
export var updateConfigurations = function updateConfigurations(data) {
  return {
    type: EMAIL_CONFIGURATIONS_UPDATE,
    data: normalize(data, [schema.emailConfiguration]).entities
  };
};
export var emailConfigurationDestroy = function emailConfigurationDestroy(id) {
  return {
    type: EMAIL_CONFIGURATION_DESTROY,
    data: id
  };
};
export var updateTemplates = function updateTemplates(data) {
  return {
    type: EMAIL_TEMPLATES_UPDATE,
    data: data
  };
};
export var emailTemplateDestroy = function emailTemplateDestroy(data) {
  return {
    type: EMAIL_TEMPLATE_DESTROY,
    data: data
  };
};